import Vue from 'vue';
import VSanitize from 'v-sanitize';

const defaultOptions = {
  allowedTags: [],
  allowedAttributes: {},
};

Vue.use(VSanitize, defaultOptions);
